import { FilterBarFieldsData } from '../../components/filterbar';
import { HelpdeskFilterBarFieldsData } from '../../helpdesk-app/components/helpdesk-filterbar';
import { AppAction } from '../actions';
import { ActionTypes } from './actionTypes';

export interface FiltersState {
  filterBar: FilterBarFieldsData;
  helpDeskFilterBar: HelpdeskFilterBarFieldsData;
}

const initialState: FiltersState = {
  filterBar: {} as FilterBarFieldsData,
  helpDeskFilterBar: {} as HelpdeskFilterBarFieldsData
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: AppAction<ActionTypes>): FiltersState => {
  switch (action.type) {
    case ActionTypes.SET_FILTER:
      return {
        ...state,
        filterBar: {
          ...state.filterBar,
          ...action.payload
        }
      };

    case ActionTypes.CLEAR_FILTERS:
      return {
        ...initialState
      };

    case ActionTypes.SET_HELPDESK_FILTER:
      return {
        ...state,
        helpDeskFilterBar: action.payload
      };

    default:
      return state;
  }
};
